import { VueRenderer } from '@tiptap/vue-2'
import tippy from 'tippy.js'
import MentionList from './MentionList.vue'
import store from '@/store'
import DBUtil from '@/utils/DBUtil'
import { unxss } from '@/utils/utils'

export default {
  char: '#',
  items: async ({ query }) => {
    // if (!query) return store.state.latest_tag_names.map((tag) => ({ name: tag }))
    // fix bug: tray 和 main 不一致
    if (!query) {
      let tagNames = await DBUtil.loadLatestTagNames()
      return tagNames.map((tag) => ({ name: unxss(tag) }))
    }
    return store.state.tags
      .filter((item) => unxss(item.name).toLowerCase().indexOf(query.toLowerCase()) > -1)
      .map((tag) => ({ name: unxss(tag.name) }))
  },
  render: () => {
    let component
    let popup

    return {
      onStart: (props) => {
        component = new VueRenderer(MentionList, {
          parent: this,
          propsData: props,
        })
        if (!props.clientRect) {
          return
        }
        popup = tippy('.editor-content', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'focusin',
          placement: 'bottom-start',
          duration: [0, 0],
          zIndex: 3000,
        })
      },

      onUpdate(props) {
        if (component) {
          component.updateProps(props)
        }
        if (!props.clientRect) {
          return
        }
        if (popup) {
          popup.map((p) => {
            p.setProps({
              getReferenceClientRect: props.clientRect,
            })
          })
        }
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup.map((p) => p.hide())
          return true
        }
        // feature : 输入新标签回车加空格(回车选中已有标签会自动加空格)
        if (props.event.key === 'Enter' && props.view.state.mention$.query) {
          props.view.dispatch(props.view.state.tr.insertText(' '))
        }
        return component && component.ref && component.ref.onKeyDown(props)
      },

      onExit() {
        if (popup) {
          popup.map((p) => p.destroy())
        }

        if (component) {
          component.destroy()
        }
      },
    }
  },
}
